import {Box, Card, Grid, Typography, useMediaQuery} from '@mui/material';
import {useIsLargeDevice, useWrappedTheme} from '@jobseeker/lotus/hooks';
// import {ButtonV2} from '@jobseeker/lotus/elements';
import {Image} from '@jobseeker/lotus/components/Image';
import PayuForm from './PayuForm';
import {PAGELIST_ID, getRefCodeAndTracking} from '@jobseeker/common-core/constants';
import {useRouter} from 'next/router';
import { PaidProducts } from '@jobseeker/feature-payment/constant';

type MembershipHeroSectionProps = {
  queryParams: {
    recappid?: string;
    refcode?: string;
    pageid?: string;
  };
};

const ProButton = ({queryParams}: MembershipHeroSectionProps) => {
  const router = useRouter();
  const isRetry = router.query.retry === 'true';
    return(
        <PayuForm
          key={'pro_membership_plan_button'}
          title={'Upgrade to PRO'}
          refCode={queryParams.refcode || '0'} 
          pageId={PAGELIST_ID[queryParams?.pageid as keyof typeof PAGELIST_ID] || '0'}
          tracking={{action: getRefCodeAndTracking(queryParams?.refcode), category: 'UpgradeToPro'}}
          autoTrigger={isRetry}
          sx={{width:155,height:32,marginTop:1}}
          product={PaidProducts.PRO_MEMBERSHIP}
        />
     
    )
  };


const MembershipHeroSection = ({queryParams}: MembershipHeroSectionProps) => {
  const theme = useWrappedTheme();
  const isAboveMobile = useIsLargeDevice('sm');
  const isTablet = useMediaQuery('(width:768px)');
  return (
    <>
      <Box
        id="membership-banner"
        sx={{
          width: '100%',
          height: {xs: 'auto', md: '342px'},
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: {xs: 2, md: 3},
          backgroundColor: '#fff',
          position: 'relative',
          overflow: 'hidden',
          '& MuiPaper-root-MuiCard-root': {
            minWidth: {xxs: 'calc(100vw - 32px)', md: 'fit-content'},
          },
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: 5,
            left: 5,
            right: 5,
            bottom: 0,
            height: {xs: '260px', md: '342px'},
            background: `url(${
              isAboveMobile
                ? `${process.env.NEXT_PUBLIC_STATIC_IIMJOBS}/static/images/mp-hero-background.svg`
                : `${process.env.NEXT_PUBLIC_STATIC_IIMJOBS}/static/images/mp-hero-background-responsive.svg`
            }) no-repeat center center`,
            backgroundSize: 'cover',
            zIndex: 0,
            borderRadius:3
          }}
        />
        <Grid container spacing={2} alignItems="center" sx={{display: 'flex'}}>
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              order: {xs: 1, md: 2},
              textAlign: 'center',
              position: 'relative',
              left: {xs: 0, md: 32},
              top: {xs: 45, md: 24},
            }}
          >
            <Box>
              <Image
                src={`${process.env.NEXT_PUBLIC_STATIC_IIMJOBS}/static/images/mp-hero-banner.svg`}
                alt="Illustration"
                width={isAboveMobile ? 435 : 270}
                height={isAboveMobile ? (isTablet ? 190 : 290) : 190}
              />
            </Box>
          </Grid>

          <Grid
            item
            xs={12}
            md={6}
            sx={{order: {xs: 2, md: 1}, textAlign: {xs: 'center', md: 'left'}}}
          >
            <Box>
              <Typography
                variant="h6"
                gutterBottom
                sx={{
                  maxWidth: {xs: '100%', md: 395,xxs:315},
                  fontSize: {xs: '18px', md: '24px',xxs:'20px'},
                  color: 'black',
                  lineHeight: {xs: '24px', md: '28px',xxs:'18px'},
                  fontWeight: 600,
                  marginTop: {xs: 8, md: 'unset'},
                }}
              >
                Want to know what&apos;s happening with your job Application?
              </Typography>
              <Box sx={{marginTop: {xs: 2.5, md: 3,xxs:2}}}>
                <Image
                  width={139}
                  height={18}
                  src={`${process.env.NEXT_PUBLIC_STATIC_IIMJOBS}/static/images/mp-less-than-12-per-day.svg`}
                  alt="Less than Rs. 12 per day!"
                />
              </Box>
              <Typography
                variant="h6"
                sx={{
                  marginTop: {xs: 0.5, sm: 2, md: -0.5},
                  fontSize: {xs: theme.typography.pxToRem(15), md: theme.typography.pxToRem(16)},
                  color: 'black',
                  lineHeight: {xs: '20px', md: '20px'},
                  fontWeight: 500,
                }}
              >
                Upgrade to Pro @ Rs 2000 for 6 months
              </Typography>
              <ProButton queryParams={queryParams}/>
              <Typography
                variant="caption"
                display="block"
                sx={{
                  maxWidth: 235,
                  marginLeft: {xs: 'auto', md: 'unset'},
                  marginRight: {xs: 'auto', md: 'unset'},
                  marginTop: {xs:1, md:1, sm: 1.5},
                  color: 'rgba(0, 0, 0, 0.35)',
                  textAlign: 'center',
                  fontSize: '10px',
                  fontStyle: 'italic',
                  fontWeight: 400,
                  lineHeight: '14px',
                }}
              >
                On click, you will be redirected to a third-party payment
                gateway, subject to its T&Cs.
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default MembershipHeroSection;
